
  export const toTitleCase = (text: string) =>
    text
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');


  export function formatearNombreCompleto(nombreCompleto: string): string {
  if (!nombreCompleto) return '';

  // Lista de conectores y preposiciones que deben ir en minúscula
  const excepciones = new Set(['de', 'la', 'las', 'del', 'los', 'y', 'e']);

  return nombreCompleto
    .trim()
    .toLowerCase()
    .split(/\s+/) // Divide por cualquier cantidad de espacios en blanco
    .map((palabra, index) => {
      // Si es la primera palabra, siempre lleva mayúscula.
      // Si está en la lista de excepciones, se queda en minúscula.
      if (index > 0 && excepciones.has(palabra)) {
        return palabra;
      }
      
      // Capitaliza la primera letra
      return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    })
    .join(' ');
}